// Cover images for the homepage "Shop by" strips.
export const coverKey = (collectionType, value) =>
  `${collectionType}:${String(value).toLowerCase()}`;

// A print carries several recommended rooms, so first-come-first-served let a
// single recent print supply the cover for every room it suits — which is why
// the Room strip showed the same three images across eight rooms.
//
// Each print now claims one cover only, and claims the scarcest collection it
// belongs to first, so a room only a handful of prints suit is not left with
// whatever is spare. A final pass fills anything still empty by reusing an
// image rather than leaving a tile blank.
export const collectCovers = (prints, keysFor) => {
  const usable = [];
  const demand = new Map();

  for (const print of prints || []) {
    const image = print.image_paths?.[0];
    if (!image) continue;

    const keys = keysFor(print).filter(Boolean);
    if (!keys.length) continue;

    usable.push({ image, keys });
    for (const key of keys) demand.set(key, (demand.get(key) || 0) + 1);
  }

  const covers = {};
  const spares = [];

  for (const { image, keys } of usable) {
    let claimed = null;
    for (const key of keys) {
      if (covers[key]) continue;
      if (!claimed || demand.get(key) < demand.get(claimed)) claimed = key;
    }
    if (claimed) covers[claimed] = image;

    const unused = keys.filter((key) => key !== claimed);
    if (unused.length) spares.push({ image, keys: unused });
  }

  for (const spare of spares) {
    for (const key of spare.keys) {
      if (!covers[key]) covers[key] = spare.image;
    }
  }

  return covers;
};
